module.exports = __webpack_public_path__ + "img/移除网络.9cd76dbd.svg";